import { render, staticRenderFns } from "./disease_science.vue?vue&type=template&id=51e8dbbd&scoped=true"
import script from "./disease_science.vue?vue&type=script&lang=js"
export * from "./disease_science.vue?vue&type=script&lang=js"
import style0 from "./disease_science.vue?vue&type=style&index=0&id=51e8dbbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8dbbd",
  null
  
)

export default component.exports